import React from 'react'
import { Flex } from 'components/Box'
import { FlexComponentSpaceBetween } from 'components/Box/AllFlexComponentStyle'
import { HeaderMenus } from '../HeaderContent'
import { HeaderMenuStyling, HeaderNavLink, HeaderSignupButton, NavbarSettingOffcanvasLaptop, NavLink, NavLinkLoginButton, PrimaryHeaderLogo } from '../HeaderStyled'
import { ReactComponent as GamesFiLogo } from 'assets/Logo/headerLogo.svg'
import { Link } from "react-router-dom"

const PrimaryHeader: React.FC = () => {
    return (
        <>
            <NavbarSettingOffcanvasLaptop>
                <FlexComponentSpaceBetween>

                    <PrimaryHeaderLogo>
                        <Link to='/'>
                            <GamesFiLogo />
                        </Link>
                    </PrimaryHeaderLogo>
                    <HeaderMenuStyling>
                        {
                            HeaderMenus.map((HeaderMenus) => (
                                <ul key={HeaderMenus.id}>
                                    <li>
                                        <HeaderNavLink href={HeaderMenus.url} >
                                            {HeaderMenus.title}
                                        </HeaderNavLink>
                                    </li>
                                </ul>
                            ))
                        }
                    </HeaderMenuStyling>
                    <Flex>
                        <NavLink to='/login'>
                            <NavLinkLoginButton>LOGIN</NavLinkLoginButton>
                        </NavLink>

                        <NavLink to='/signup'>
                            <HeaderSignupButton>SIGNUP</HeaderSignupButton>
                        </NavLink>
                    </Flex>

                </FlexComponentSpaceBetween>
            </NavbarSettingOffcanvasLaptop>
        </>
    )
}

export default PrimaryHeader;